export default "__VITE_ASSET__DVNFPkiK__"